module.exports = __webpack_public_path__ + "img/wecare-samsung-s10.ff96f2b7.png";